import React from "react";
import { Navigate, Outlet } from "react-router";
import { logger } from "utils";
import { useAuthContext } from "contexts";

/**
 * DistrictRoute
 * -------------
 * Wrapper for all district pages. The open district is the user's primary
 * district (see selectDistrictData), so nothing is loaded here; a user who
 * has just verified is sent to /verify_complete first.
 */
const DistrictRoute = () => {
  const { isVerify } = useAuthContext();

  if (!!isVerify && isVerify) {
    logger.log("verify storage value", isVerify);
    return <Navigate to="/verify_complete" replace />;
  }
  // if(!districtId) {
  //   return;
  // }
  return <Outlet />;
};

export default DistrictRoute;
